export default class Nature {
    serialize() {
        return {
            name: this.name,
        };
    }

    static deserialize(data) {
        console.log(`Serializing ${this.constructor.name}`);
        return new Nature({
            name: data.name,
        });
    }

    constructor(options = {}) {
        const natures = {
            adamant: {
                increasedStat: 'attack',
                decreasedStat: 'specialAttack',
            },
            bashful: {
                increasedStat: 'specialAttack',
                decreasedStat: 'specialAttack',
            },
            bold: { increasedStat: 'defense', decreasedStat: 'attack' },
            brave: { increasedStat: 'attack', decreasedStat: 'speed' },
            calm: { increasedStat: 'specialDefense', decreasedStat: 'attack' },
            careful: {
                increasedStat: 'specialDefense',
                decreasedStat: 'specialAttack',
            },
            docile: {},
            gentle: {
                increasedStat: 'specialDefense',
                decreasedStat: 'defense',
            },
            hardy: {},
            hasty: { increasedStat: 'speed', decreasedStat: 'defense' },
            impish: {
                increasedStat: 'defense',
                decreasedStat: 'specialAttack',
            },
            jolly: { increasedStat: 'speed', decreasedStat: 'specialAttack' },
            lax: { increasedStat: 'defense', decreasedStat: 'specialDefense' },
            lonely: { increasedStat: 'attack', decreasedStat: 'defense' },
            mild: { increasedStat: 'specialAttack', decreasedStat: 'defense' },
            modest: { increasedStat: 'specialAttack', decreasedStat: 'attack' },
            naive: { increasedStat: 'speed', decreasedStat: 'specialDefense' },
            naughty: {
                increasedStat: 'attack',
                decreasedStat: 'specialDefense',
            },
            quiet: { increasedStat: 'specialAttack', decreasedStat: 'speed' },
            quirky: {},
            rash: {
                increasedStat: 'specialAttack',
                decreasedStat: 'specialDefense',
            },
            relaxed: { increasedStat: 'defense', decreasedStat: 'speed' },
            sassy: { increasedStat: 'specialDefense', decreasedStat: 'speed' },
            serious: {},
            timid: { increasedStat: 'speed', decreasedStat: 'attack' },
        };

        // Get an array of nature names
        const natureNames = Object.keys(natures);

        // Use provided name or select a random nature name
        const name = options.name || natureNames[Math.floor(Math.random() * natureNames.length)];

        // Set the properties of the nature
        this.name = name;
        this.increasedStat = natures[name].increasedStat;
        this.decreasedStat = natures[name].decreasedStat;
    }

    displayName() {
        return this.name.charAt(0).toUpperCase() + this.name.slice(1);
    }

    statModifier(stat) {
        if (this.increasedStat === stat && this.decreasedStat === stat) {
            return 1;
        } else if (this.increasedStat === stat) {
            return 1.1;
        } else if (this.decreasedStat === stat) {
            return 0.9;
        } else {
            return 1;
        }
    }

    shortStatSummary() {
        if (this.increasedStat === this.decreasedStat) {
            return '--';
        }

        function humanizeStat(stat) {
            switch (stat) {
                case 'attack':
                    return 'ATK';
                case 'defense':
                    return 'DEF';
                case 'specialAttack':
                    return 'SP.ATK';
                case 'specialDefense':
                    return 'SP.DEF';
                case 'speed':
                    return 'SPD';
            }
        }

        return `+${humanizeStat(this.increasedStat)}  -${humanizeStat(this.decreasedStat)}`;
    }

    summaryString() {
        let curString = `${this.name.toUpperCase()} nature.  `;

        if (this.increasedStat === this.decreasedStat) {
            return `${curString}It has no effect on its stats.`;
        }

        function humanizeStat(stat) {
            switch (stat) {
                case 'attack':
                    return 'ATK';
                case 'defense':
                    return 'DEF';
                case 'specialAttack':
                    return 'SP.ATK';
                case 'specialDefense':
                    return 'SP.DEF';
                case 'speed':
                    return 'SPD';
            }
        }

        curString += `↑ ${humanizeStat(this.increasedStat)}, ↓ ${humanizeStat(this.decreasedStat)}.`;
        return curString;
    }
}
